import ModalView from 'common-views/ModalView';
import template  from 'common-views/session-timeout-modal.ejs';


class SessionTimeoutModal extends ModalView {

    initialize(){
        super.initialize();
        this.template = template;
    }
    
    render(){
        
        return new Promise((resolve, reject) => {
            const settings = this.settings;
            settings.height = 150;
            settings.width = 430;

            settings.buttons = [
                {
                    text: 'OK',
                    click: () => {                      
                        resolve("close");
                        this.closeModal();
                    }
                }
            ];

            settings.close = () => {
                resolve("close");
            };

            if(this.template) {
                this.$el.html(this.template(this.model.toJSON()));
            }
            super.render();

        });
    }
}

export default SessionTimeoutModal;